import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { setToken, ApiError } from '../api';

interface LoginResponse {
  token: string;
  user: { email: string; oidc_subject: string };
}

export default function LoginPage() {
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      if (!res.ok) {
        const body = (await res.json().catch(() => ({}))) as { error?: string };
        throw new ApiError(res.status, body.error ?? res.statusText);
      }
      const data = (await res.json()) as LoginResponse;
      setToken(data.token);
      nav('/cluster');
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-100 p-6">
      <div className="panel w-full max-w-md">
        <div className="panel-h">Leitstand — Anmeldung</div>
        <div className="panel-b">
          <p className="text-[12.5px] text-neutral-700 mb-3">
            ePerformance Plattform-Admin. Phase-4-Stop-Gap mit Email/Passwort; Phase-5
            ersetzt das durch OIDC (STACKIT IAM, ADR-0011).
          </p>
          <form onSubmit={onSubmit} className="space-y-3">
            <div>
              <label htmlFor="email" className="block text-[12px] text-neutral-700 mb-0.5">
                Email
              </label>
              <input
                id="email"
                type="email"
                className="input w-full"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username"
                required
              />
            </div>
            <div>
              <label htmlFor="password" className="block text-[12px] text-neutral-700 mb-0.5">
                Passwort
              </label>
              <input
                id="password"
                type="password"
                className="input w-full"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
            </div>
            {error && (
              <div className="border border-st-err bg-red-50 text-st-err px-2 py-1 text-[12px]">
                {error}
              </div>
            )}
            <div className="flex justify-end pt-1">
              <button
                type="submit"
                className="btn-primary"
                disabled={busy || email.length === 0 || password.length === 0}
              >
                {busy ? 'Pruefe...' : 'Anmelden'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
